.card {
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  background: var(--card);
  padding: 0.875rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  cursor: pointer;
  text-align: left;
}

.card:hover {
  border-color: var(--rule-strong);
}

.value {
  font-family: var(--font-display);
  font-size: 1.75rem;
  line-height: 1.1;
  color: var(--ink);
}

.label {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ink-soft);
}

.detail {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--muted);
}
